import http from "axios";
import axios from "axios";

class UploadFilesService {
  upload(files, onUploadProgress) {
    // alert("Uploading", file.name)
    // console.log('xxxx', file, onUploadProgress)
    // for( var i = 0; i < files.length; i++ ){
    let formData = new FormData();

    formData.append("file", files);
    // console.log( 'form-data',files[i].name)

     return axios.post("/Settings/uploadfiles", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': localStorage.getItem('token')
      },
      onUploadProgress
    });
    // alert('am here', files[i].name)

    // return 1;

    // return 'Upload of the file' + ' '+ files[i].name + ' ' + 'successfull';

  // }
}

  getFiles() {
    return http.get("Settings/getcompanies", {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then((response)=>{
      // console.log(response.data);
      this.items = response.data;
      // console.log('companies',this.items);
      this.companyCodes = this.items.map((item) => {
        // this.id = item.id
        return item.code
      })
      this.companyCodes.forEach(code =>{
        // this.CompanyDetails.companyCode = code;
        http.get("Settings/getcompanyfiles", {
          params: {
            companycode: code
          },
          headers: {
            'Authorization': localStorage.getItem('token')
          }

        })
        //     .then((response) => {
        //   // debugger;
        //
        //   this.files = response.data
        //   console.log('all files',this.files)
        //
        // })
      })




    })

  }
}

export default new UploadFilesService();